/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { ConfirmModal, IErrorMessage } from "@advapacs/common";
import React, { FC, useState } from "react";
import LogoutIcon from "@src/assets/icons/logout-ic.svg";
import { useAppDispatch } from "@src/config/store";
import { logout } from "@src/pages/unauthenticated/ducks/operations";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PatientLogo } from "../PatientLogo";
import { useLogoUrl } from "@src/hooks/useLogoUrl";

interface INavbar {
  isAuthenticated?: boolean;
  setLogoutErrorMessage?: (err: IErrorMessage) => void;
}

export const Navbar: FC<INavbar> = ({
  isAuthenticated,
  setLogoutErrorMessage,
}) => {
  const dispatch = useAppDispatch();
  const logoUrl = useLogoUrl();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const handleLogout = async () => {
    try {
      dispatch(logout());
    } catch (error) {
      if (setLogoutErrorMessage)
        setLogoutErrorMessage((error as IErrorMessage)?.response?.data);
    }
  };
  return (
    <>
      {showLogoutModal && (
        <ConfirmModal
          body="Are you sure you want to Sign Out of the Patient Portal?"
          confirmBtnName="Sign Out"
          cancelBtnName="Cancel"
          cancel={() => {
            setShowLogoutModal(false);
          }}
          confirm={() => {
            handleLogout();
            setShowLogoutModal(false);
          }}
          show={showLogoutModal}
        />
      )}

      <div className="navbar navbar-expand-xl navbar-static bg-white landing-fixed-top border-default-bottom">
        <div className="container-fluid landing-navbar">
          <div
            className={`${
              !!logoUrl ? "p-b-none p-t-none" : ""
            } navbar-brand flex-1 d-flex justify-content-between align-items-center`}
          >
            <PatientLogo
              height={44}
              type="contain"
              width={220} // max-width for logo.
              className="d-inline-flex align-items-center p-tb-xxs"
              logoUrl={logoUrl as string}
              hasLink
              link="/"
            />

            {isAuthenticated && (
              <OverlayTrigger
                placement="left"
                trigger={["focus", "hover"]}
                container={document.body}
                overlay={<Tooltip>Sign Out</Tooltip>}
              >
                <img
                  style={{ height: "0.91rem" }}
                  onClick={() => {
                    setShowLogoutModal(true);
                  }}
                  src={LogoutIcon}
                  alt="Sign Out"
                  className="cursor-pointer"
                />
              </OverlayTrigger>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
